import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  /** 16px gap between blocks is applied in `Page` via `Stack`; this is the inner column only. */
  pageSections: {
    minWidth: 0,
    width: '100%',
  },
  paragraphContainer: {
    padding: 0,
  },
  externalLink: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
}));
